import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AvailabilityApiService {

    private readonly apiUrl = `${environment.baseUrl}availability`;

    constructor(private http: HttpClient) { }

    /** ✅ Fetch availability for a property */
    get(propertyId: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/${propertyId}`);
    }

    /** ✅ Check for future booking conflicts before saving */
    checkConflicts(payload: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/check-conflicts`, payload);
    }

    /** ✅ Final update after confirm */
    update(payload: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/update`, payload);
    }
}
